import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getSlider(id, session_id=0) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/slider/get?id='+id+'&session_id='+session_id);
      const items = await axios.get('/api/slider/items?id='+id+'&session_id='+session_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_SLIDER', data: payload, items: items.data.payload })
        return data.payload;
      } else {
        dispatch({type: 'GET_SLIDER', data: {}, items: [] })

        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_SLIDER', data: {}, items: [] })
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getSessions(slider_id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/slider/sessions?slider_id='+slider_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_SLIDER_SESSIONS', data: payload, })
        return data.payload;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }
}

export async function getQuestionAnswer(session_id) {
 
  try {
    const {data} = await axios.get('/api/slider/question-answer?session_id='+session_id);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
  
}


export async function genStatisticAnswerFile(session_id) {

    try {
        const {data} = await axios.get('/api/slider/import-exel?session_id='+session_id);

        if(data.errcode == 200) {
            return {
              status: true,
              fileName: data.fileName,
            };
        } else {
          return {
            status: false
          };
        }
    } catch (error) {
      return {
        status: false
      };
    }

}

export async function getMessage(session_id) {
 
  try {
    const {data} = await axios.get('/api/slider/student-message?session_id='+session_id);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
  
}

export function setSliderSlide(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_SLIDER_SLIDE', data })
  }
}
export function clearSlider(data) {
  return async (dispatch) => {
    dispatch({type: 'CLEAR_SLIDER' })
  }
}


export async function addSlideImage(body) {
  
    try {
      var bodyFormData = new FormData();
      bodyFormData.append('UploadFiles[imageFiles]', body.image );
      bodyFormData.append('pr_id', body.pr_id );
      bodyFormData.append('order_x', body.order_x );
      const {data} = await axios({
        method: 'post',
        url: '/api/slider-item/post',
        data: bodyFormData,
        headers: {'Content-Type': 'multipart/form-data' }
      });

      if(data.errcode == 200) {
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return null; 
    }
}

export function addImages(images, pr_id, length = 0) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDER_LOADED_IMGS', data: false})
      let i=1;
      for(const file of images) {
        let data = await addSlideImage({
          image: file.item,
          pr_id,
          order_x: length + i ,
        });
        dispatch({type: 'ADD_SLIDER_ITEM', data })
        i++;
      }
      setTimeout(() => {
        dispatch({type: 'SET_SLIDER_LOADED_IMGS', data: true})
      }, 500);
      
      return true;
    } catch (error) {
      dispatch({type: 'SET_SLIDER_LOADED_IMGS', data: true})
    }
  }
}



export function setLoaded(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_SLIDER_LOADED', data})
  }
}

export function deleteSliderItem(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider-item/delete', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_SLIDER_ITEM', data: id});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteSliderItems(ids) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider-item/delete', {ids: JSON.stringify(ids)});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_SLIDER_ITEMS', data: ids});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export  function updateSliderItemOrder(orders) {
  return async(dispatch) => {
    try {
      dispatch({type: 'SET_SLIDER_LOADED', data: false})
      const {data} = await axios.post('/api/slider-item/order', {orders: JSON.stringify(orders)});
      dispatch({type: 'SET_SLIDER_ORDERS', data: orders})
      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'SET_SLIDER_LOADED', data: true})
        return data;
      } else {
        // TODO error
        dispatch({type: 'SET_SLIDER_LOADED', data: true})
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'SET_SLIDER_LOADED', data: true})
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/actions.js